import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Analytics Config',
  attributeName: 'analyticsConfig',
  fields: [
    {
      attributeName: 'analyticsHost',
      helpText: 'The host where  the reports will be posted.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Analytics Host',
      placeholder: 'Input analytics host...',
      default: '',
    },
    {
      attributeName: 'analyticsProtocol',
      helpText: 'The protocol used for analytics.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Analytics Protocol',
      placeholder: 'Input analytics protocol...',
      default: '',
    },
    {
      attributeName: 'analyticsPort',
      helpText: 'The port configuration of the analytics endpoint.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Analytics Port',
      placeholder: 'Input an Analytics Port...',
      default: 0,
    },
    {
      attributeName: 'eventIndex',
      helpText: 'Elasticsearch index to track Events from the Analytics Reporter in the Android SDK',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Event Index',
      placeholder: 'Event index...',
      default: '',
    },
    {
      attributeName: 'videoPlayerIndex',
      helpText: 'Elasticsearch index where the video player metrics will be stored.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Video Player Index',
      placeholder: 'Input video player index...',
      default: '',
    },
    {
      attributeName: 'videoPlayerReportingPace',
      helpText: 'Time in milliseconds for video player analytics reporting frequency.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Video Player Reporting Pace',
      placeholder: 'Input a video Player reporting pace...',
      default: 0,
    },
    {
      attributeName: 'uxIndex',
      helpText: 'Elasticsearch index where the UX metrics will be stored.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'UX Index',
      placeholder: 'Input UX index...',
      default: '',
    },
    {
      attributeName: 'uxReportingPace',
      helpText: 'Time in milliseconds for user experience analytics reporting frequency.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'UX Reporting Pace',
      placeholder: 'Input UX Reporting pace...',
      default: '',
    },
    {
      attributeName: 'analyticsDocType',
      helpText: 'The document type within the index under which the reports will be posted.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Doc Type',
      placeholder: 'Input analytics index...',
      default: '',
    },
    {
      attributeName: 'viewportChangeIndex',
      helpText: 'The index where viewport and camera change reports will be posted.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Viewport Change Index',
      placeholder: 'Input a Viewport Change Index...',
      default: '',
    },
    {
      attributeName: 'analyticsBufferSize',
      helpText: 'How many individual reports will be buffered before sending a bulk JSON to the endpoint. This is to prevent client overload of requests.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Analytics Buffer Size',
      placeholder: 'Input analytics buffer size...',
      default: 0,
    },
    {
      attributeName: 'sameContentTimestampThreshold',
      helpText: 'How long to wait for the player to move its playback position before the data collector suspends sending data (seconds)',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Same Content Timestamp Threshold',
      placeholder: 'Input Timestamp Threshold...',
      default: 0,
    },
  ],
};
